import React from 'react';
import { T, fonts } from '../theme/tokens';
import { NdcLogo } from './atoms';

export function Masthead() {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: 34,
        flexWrap: "wrap",
        gap: 6,
      }}
    >
      <a href="https://www.neildunlopconsulting.com" style={{ textDecoration: "none" }}>
        <NdcLogo size={16} />
      </a>
      <span style={{ fontFamily: fonts.body, fontSize: 11, fontWeight: 600, color: T.accent, letterSpacing: "2px", textTransform: "uppercase" }}>
        AI READINESS REVIEW
      </span>
    </div>
  );
}
